import { render, staticRenderFns } from "./FavouriteAuthDialog.vue?vue&type=template&id=7a9c3456"
import script from "./FavouriteAuthDialog.vue?vue&type=script&lang=js"
export * from "./FavouriteAuthDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports